import DRadioGroup from '~/components/common/DRadioGroup.vue'

export type DroppedIndex = {
  x: number
  y: number
  e: DragEvent | null
}

export const useGlobalDragAndDropStore = defineStore('dragAndDrop', () => {
  const isDrag = ref(false)
  const droppedIndex = ref({ x: -1, y: -1, e: null } as DroppedIndex)

  const dragging = () => {
    isDrag.value = true
    droppedIndex.value = { x: -1, y: -1, e: null }
  }

  const undragging = () => {
    isDrag.value = false
  }

  const setDroppedIndex = (clientX: number, clientY: number, e: DragEvent) => {
    droppedIndex.value = { x: clientX, y: clientY, e: e }
  }

  return {
    isDrag: readonly(isDrag),
    droppedIndex: droppedIndex,
    dragging,
    undragging,
    setDroppedIndex,
  }
})
